export const CLOVER_PRIVACY_POLICY_URL =
  'https://www.clover.com/privacy-policy';

export const CI_PORT_QUERY_KEY = 'ci-port';

export const MEDIA_URL = 'https://media-cdn.getbento.com';
